import { useState } from "react";
import OrbButton from "../../../../../shared/components/orb-button";
import SyPopup from "../../../../../shared/components/sy-model";
import SplashInfoPop from "../../../popups/splash-info-popup";
import { useSelector } from "react-redux";
import { getImageDetails } from "../../../../../feature/image-slice";
import styleSheet from "../style.module.scss";
import SplashAnimation from "../splash-animation";
import { Canvas, useFrame } from "@react-three/fiber";
const SplashComponent = (props: any) => {
  const { onCloseLoading } = props;
  const [openInfoText, setOpenInfoText] = useState<any>(null);
  const [close, setClose] = useState(false);
  const imageSlice = useSelector(getImageDetails);
  const onCloseInfoPopup = () => {
    // setOpenInfoText(false);
  };

  const onClickInfo = () => {
    setOpenInfoText("info");
  };

  const onCloseSplash = () => {
    setOpenInfoText("close");
    setTimeout(() => {
      setOpenInfoText('stop');
      setClose(true);
         }, 1000);

  };

  const onCloseComplete = () => {
    setClose(false);
    onCloseLoading();
  };
  return (
    <>
   

      <div className="w-100 h-100">
        <div className=" d-flex justify-content-end mb-4 gap-3 p-3  ">
          
          <OrbButton
            className={" mohave "}
            label={"close"}
            onBtnClick={onCloseSplash}
          />
        </div>
        {/* <div className="row w-100 h-100">
          <div className="col position-relative">
            <div className=" position-absolute top-25 font-20 text-white  opacity-75 ">
              <p className="mohave  ps-4">
                            Stell dir vor, du reist durch die Sterne – und jeder Planet
                erzählt dir seine eigene Geschichte. In diesem Kosmos findest du
                ganze Orbits sozialer Organisationen. Ihre Planeten sind
                spannende Projekte, die darauf warten, entdeckt zu werden. Klick
                dich hinein, erfahre, was ein Planet zu bieten hat, was er noch
                sucht, und lande mit deiner Crew mitten im Geschehen. Werde
                Bewohner:in, teile Ideen im Bordfunk, unterstütze mit einer
                Spende oder hinterlasse ein kosmisches Like. Aus vielen kleinen
                Sternen entsteht so eine große Gemeinschaft – bereit, Funken der
                Veränderung in neue Welten zu tragen. Mach dich bereit,
                Raumreisende:r – dein Abenteuer beginnt jetzt!
              </p>
            </div>
          </div>
          <div className="col ">
            <Canvas>
              <SplashAnimation close={close} onCloseComplete={onCloseComplete} />
            </Canvas>
          </div>
        </div> */}



        <Canvas>
          <SplashAnimation
            close={close}
            text={openInfoText}
            onCloseComplete={onCloseComplete}
          />
        </Canvas>
        </div>
  
    </>
  );
};
export default SplashComponent;
